var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("svg", {
    directives: [
      { name: "show", rawName: "v-show", value: false, expression: "false" },
    ],
    ref: "root",
    attrs: { id: "sv-icon-holder-global-container" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }